import ByzMuiTypography from "src/components/core-components/mui/inputs/ByzMuiTypography";
import { useTranslate } from "src/locales";

function Footer() {
  const { t } = useTranslate();
  return <ByzMuiTypography isTitle= {false} >{t("modified-aldrete.footer-text")}</ByzMuiTypography>
}

export default Footer;
